module.exports = __webpack_public_path__ + "@/assets/img/debt-icon.018e33c7.svg";